import { useEffect, useRef } from 'react';
// import { toast } from 'react-toastify';
import Modal from '../../../../../common/_custom/Modal/Modal';

export default function FinboxModal({ showFinbox, finboxUrl, onSuccess, onExit, onError }: any) {
    const callbacksRef = useRef({ onSuccess, onExit, onError });
    useEffect(() => {
        callbacksRef.current = { onSuccess, onExit, onError };
    });

    useEffect(() => {
        const handleMessage = (e: any) => {
            let data = e.data;
            if (typeof data === 'string') {
                try {
                    data = JSON.parse(data);
                } catch {
                    return;
                }
            }
            if (data?.status === 'exit') {
                callbacksRef.current.onExit(data.payload);
            } else if (data?.status === 'success') {
                callbacksRef.current.onSuccess(data.payload);
            } else if (data?.status === 'error') {
                callbacksRef.current.onError(data.payload);
            }
        };
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    if (finboxUrl) {
        return (
            <div>
                <Modal open={showFinbox} onClose={onExit} size="flexible" withoutCloseButton>
                    <iframe title="Finbox" src={finboxUrl} width="470px" height="700px" />
                </Modal>
            </div>
        );
    } else {
        // toast.error('Some error occurred');
        return null;
    }
}
